"use strict";

require("core-js/shim");

require("regenerator/runtime");

if (global._babelPolyfill) {
  throw new Error("only one instance of babel/polyfill is allowed");
}
global._babelPolyfill = true;


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-core/lib/polyfill.js
 ** module id = 251
 ** module chunks = 0
 **/